import { api } from '../../App'
import { createNotification } from '../../components/Notifications/Notifications'
import { SET_PERSONNEL_LOADING } from '../types'

// GET /personnel_structure/{mid}/photo — фото сотрудника (blob), 404 если отсутствует
export const getPersonnelPhoto = (mid) => async () => {
  try {
    const response = await api.get(`/personnel_structure/${mid}/photo`, { responseType: 'blob' })
    return response.data
  } catch (ERR) {
    return null
  }
}

// POST /personnel_structure/{mid}/photo — загрузка/замена фото (FormData, поле 'photo')
export const uploadPersonnelPhoto = (mid, file) => async (dispatch) => {
  let success = false
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true })
    const formData = new FormData()
    formData.append('photo', file)
    await api.post(`/personnel_structure/${mid}/photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    success = true
    createNotification('success', 'Фото успешно загружено')
  } catch (ERR) {
    console.error('uploadPersonnelPhoto error:', ERR)
    createNotification('error', ERR?.response?.data?.detail || 'Ошибка загрузки фото')
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false })
    return success
  }
}

// DELETE /personnel_structure/{mid}/photo — удаление фото
export const deletePersonnelPhoto = (mid) => async (dispatch) => {
  let success = false
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true })
    await api.delete(`/personnel_structure/${mid}/photo`)
    success = true
    createNotification('success', 'Фото успешно удалено')
  } catch (ERR) {
    console.error('deletePersonnelPhoto error:', ERR)
    createNotification('error', ERR?.response?.data?.detail || 'Ошибка удаления фото')
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false })
    return success
  }
}
